import React, {Fragment} from "react";

import {AsyncSelect, Props as SelectProps} from "./select";

export function Card(props: {title: string, children?, body?, actions?}){
	return (
		<div className="card">
			{
				props.title && (
		      <div className="card-header">
		        <h3 className="card-title">{props.title}</h3>
		        {
		        	props.actions && (
		        		<div className="card-actions">
		        			{props.actions}
		        		</div>
		        	)
		        }
		      </div>
				)
			}
			{
				props.children ? 
      	<div className="card-body">{props.children}</div> :
      	props.body
			}
    </div>
	)
}
export function AddLink(props: {children, onClick}){
	return (
		<span className="text-blue cursor-pointer" onClick={props.onClick}>
			{props.children}
		</span>
	)
}
export function LoadingSpinner(props: {}){
	return (
		<Fragment>
			<div className="spinner-border" ></div>
		</Fragment>
	)
}
export class ErrorBoundary extends React.Component<{children}> {
	state = {
		error: false,
		err: null as any
	}
	static getDerivedStateFromError(err){
		return {
			error: true,
			err
		}
	}
	render(){
		if(this.state.error){
			return (
				<ErrorStripe
					message={"Something went wrong!"}
					explanation={
						this.state.err.errors ?
							this.state.err.errors[0].message :
							this.state.err
					}
				/>
			)
		}
		return (
			this.props.children
		)
	}
}
export function Button(
	props: {
		onClick?,
		children?,
		className?: string,
		primary?: boolean,
		danger?: boolean,
		spinning?: boolean,
		disabled?: boolean
	}
){
	return (
		<button
			children={props.children}
			className={
				"btn  " +
				(props.className ?? "") +
				(props.primary ? " btn-primary " : "") +
				(props.disabled ? " disabled " : "") +
				(props.danger ? " btn-danger " : "") +
				(props.spinning ? " btn-loading " : "")
			}
			onClick={props.onClick}
		/>
	)
}
export function Modal(
	props: {
		children,
		title: string,
		footer,
		close: () => void
	},
){
	return (
		<div className="modal modal-blur fade show" id="modal-team" tabIndex={-1} role="dialog" aria-modal="true" >
			<div className="modal-dialog modal-dialog-centered" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">{props.title}</h5>
						<button type="button" onClick={props.close} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div className="modal-body">
						{props.children}
					</div>
					<div className="modal-footer">
						{props.footer}
					</div>
				</div>
			</div>
		</div>
	)
}
export function useRelayErrors(){
	const [errors, setErrors] = React.useState<HttpError[]>([]);
	const _errs =  React.useMemo(
		function () {
			// let paths = lodash.castArray(e);
			return (
				errors.reduce(
					function (ac, error) {
						let pt = error.path.slice(1).toString();
						ac[ pt ] = error.message;
						return ac;
					},
					{} as {[key: string]: string}
				)
			)
		},
		[errors]
	);
	function onError(err: any){
		setErrors(err.errors || []);
	}
	return [
		onError,
		_errs,
		setErrors,
		errors
	] as const;
}
export function ErrorStripe(props: {message: string, explanation?: string}){
	return (
		<div className="alert alert-danger">
      <h4 className="alert-title">{props.message}</h4>
      {
      	props.explanation &&
      	<div className="text-muted">{props.explanation}</div>
      }
    </div>
	)
}
export function FormGroup(props: {children, label: string}){
	return (
		<div className="mb-3">
      <label className="form-label">{props.label}</label>
      {props.children}
    </div>
	)
}
export function InputComponent(props: {value, onChange, placeholder?: string, error?: string, name?: string, type?: string}){
	return (
		<div>
			<input
				// type="text"
				className={"form-control " + (props.error ? "is-invalid" : "")}
				name="example-text-input"
				placeholder="Input placeholder"
				{...props}
			/>
			{
				props.error && (
					<div className="invalid-feedback">{props.error}</div>
				)
			}
		</div>
	)
}
export function DeleteModalComponent(
	props: {
		title: string,
		children: string
		onConfirm: () => void
		onCancel: () => void
		loading: boolean
		error?: string
	}
){
	return (
		<div className="modal modal-blur fade show" >
		  <div className="modal-dialog modal-sm modal-dialog-centered" >
		    <div className="modal-content">
		      <button type="button" onClick={props.onCancel} className="btn-close" ></button>
		      <div className="modal-status bg-danger"></div>
		      <div className="modal-body text-center py-4">
		        <i className="ts alert-triangle mb-2 text-danger icon-lg"></i>
		        <h3>{props.title}</h3>
		        <div className="text-muted">{props.children}</div>
		        {
		        	props.error && <ErrorStripe message={props.error} />
		        }
		      </div>
		      <div className="modal-footer">
		        <div className="w-100">
		          <div className="row">
		            <div className="col">
		              <Button className="w-100" children="Cancel" onClick={props.onCancel} />
		            </div>
		            <div className="col">
		              <Button className="w-100" children="Delete" spinning={props.loading} danger onClick={props.onConfirm} />
		            </div>
		          </div>
		        </div>
		      </div>
		    </div>
		  </div>
		</div>
	)
}
export function FunnelsListPickerApp(props: SelectProps){
	return (
		<AsyncSelect
			{...props}
		/>
	)
}
export {Upgrade} from "./upgrade";
export {
	AsyncSelect
}